/** First option index the keyboard may highlight, or -1 when every option is skipped. */
export function findFirstEnabledIndex(n: number, isSkipped: (index: number) => boolean): number {
  for (let i = 0; i < n; i += 1) {
    if (!isSkipped(i)) {
      return i
    }
  }

  return -1
}

/**
 * Arrow-key highlight step over `n` options, skipping disabled ones. From no highlight
 * (`prev < 0`) Down starts at the top and Up at the bottom; otherwise the move clamps at the ends.
 * Returns the new index, or null when the highlight should stay where it is.
 */
export function resolveNextHighlightIndex(
  prev: number,
  delta: number,
  n: number,
  isSkipped: (index: number) => boolean
): number | null {
  const step = delta > 0 ? 1 : -1
  let next: number

  if (prev < 0) {
    next = delta > 0 ? 0 : n - 1
  } else {
    next = Math.min(n - 1, Math.max(0, prev + delta))
  }

  let guard = 0

  while (guard < n && isSkipped(next)) {
    if (prev < 0) {
      next += step
      if (next < 0 || next >= n) {
        return null
      }
    } else {
      const atEnd = step > 0 ? next >= n - 1 : next <= 0

      if (atEnd) {
        return null
      }

      next += step
    }

    guard += 1
  }

  if (isSkipped(next)) {
    return null
  }

  return next
}
